import company_favicon from '../assets/img/icon-128.png'
import company_logo from '../assets/img/icon-128.png'

const siteConfig = {
    company_name: 'Focusly.pro',
    company_favicon: company_favicon,
    lazy_suspense_delay: 300,
    company_logo: company_logo,
    maintenance_time: 2,
    support_email: 'hello@shadhinlab.com',
    premium_fee: 2.99,
}

export default siteConfig;